"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthClient = void 0;
const api_1 = require("../core/api");
const USER_AUTH_TOKEN = 'x-eusi-user-auth-token';
class AuthClient {
    constructor(config) {
        this.config = config;
        this.api = new api_1.ApiService(config);
    }
    /**
     * Performs user login operation
     * @param body @type Login
     */
    login(body) {
        const { api } = this;
        return api.post(["auth/login"], body);
    }
    /**
     * Perform login operation by short lived token
     * @param body @type LoginByTokenDto
     */
    loginByToken(body) {
        const { api } = this;
        return api.post(['auth/login/token'], body);
    }
    /**
     * Performs user registration verification
     * @param body @type Verify
     */
    verify(body) {
        const { api } = this;
        return api.post(["auth/verify"], body);
    }
    /**
     * Performs user authentication
     * @param authenticationToken @type string
     */
    authenticate(authenticationToken) {
        const { api } = this;
        const config = { headers: {} };
        config.headers[USER_AUTH_TOKEN] = authenticationToken;
        return api.get(["auth/authenticate"], null, config);
    }
    /**
     * Performs user logout
     * @param authenticationToken @type string
     */
    logout(authenticationToken) {
        const { api } = this;
        const config = { headers: {} };
        config.headers[USER_AUTH_TOKEN] = authenticationToken;
        return api.post(["auth/logout"], null, config);
    }
    /**
     * Fetch for user's data by specified user's authentication token
     * @param authenticationToken @type string
     */
    getUserData(authenticationToken) {
        const { api } = this;
        const config = { headers: {} };
        config.headers[USER_AUTH_TOKEN] = authenticationToken;
        return api.get(["auth/user/data"], null, config);
    }
}
exports.AuthClient = AuthClient;
//# sourceMappingURL=auth.client.js.map